import React, { useState } from "react";
import { useParams } from "react-router-dom";
import SearchBar from "../../NewComponent/SearchBar/SearchBar";

export default function QuestionBox() {
  const [isShow, setShow] = useState(false);
  const { textparam } = useParams();
  const TextStyles = {
    "font-size": "24px",
    "font-weight": "300",
    "line-height": "32px",
    "text-align": "left",
    color: "#2A364A",
    // wordBreak: "break-all",
    display: "flex",
    alignItems: "baseline",
    marginBottom:'16px'
  };
  return (
    <>
      {/* {isShow ? ( */}
       <div className="mb-5">
       <SearchBar />
       </div>
      {/* // ) : (
      //   <div style={TextStyles}>
      //     {textparam} */}
          {/* &nbsp;
          <i
          onClick={()=>setShow(true)}
            className="fa fa-edit"
            style={{
              fontWeight: "500",
              color: "#2A364A",
              fontSize: "24px",
              cursor: "pointer",
            }}
          ></i> */}
      {/* //   </div> */}
      {/* // )} */}
    </>
  );
}
